<template>
  <div>
    <base-header class="pb-6">
      <b-row align-v="center" class="py-4">
        <b-col cols="7" lg="6">
          <h6 class="h2 text-white d-inline-block mb-0">Leaderboards</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
      </b-row>
    </base-header>
    <b-container fluid class="mt--6">
      <b-row>
        <b-col lg="3" md="4">
          <b-list-group>
            <b-list-group-item class="d-flex justify-content-between align-items-center">
              <strong>LEADERBOARDS</strong>
              <div v-if="roles.includes('owner')">
                <b-button size="sm" variant="primary" @click="editing = true" v-if="!editing">Edit</b-button>
                <b-button size="sm" variant="success" @click="editing = false" v-else><i class="fas fa-check"></i></b-button>
              </div>
            </b-list-group-item>
            <b-list-group-item class="d-flex justify-content-between align-items-center" button v-for="(item, key) in menu" @click="editMenu(item)" :key="key" :active="leaderboards.includes(item.value)">
              <span>{{ item.title }}</span>
              <!-- <span v-if="!editing">
                <i class="fas fa-check-square text-white" v-if="leaderboards.includes(item.value)"></i>
                <i class="far fa-square" v-else></i>
              </span> -->
              <i class="fas fa-trash-alt text-danger" v-if="editing && key !== 0"></i>
            </b-list-group-item>
            <b-list-group-item button @click="addLeaderboard = !addLeaderboard" v-if="roles.includes('owner')">
              <div v-if="!addLeaderboard" class="small text-center"><strong><i class="fas fa-plus"></i> Add Leaderboard</strong></div>
              <div v-else>
                <b-input-group class="mt-3">
                  <template #append>
                    <b-button variant="danger"><i class="fas fa-times"></i></b-button>
                  </template>
                  <el-select
                    filterable
                    class="select-primary pagination-select small w-75"
                    v-model="boardToAdd"
                    placeholder="Select Metric" @change="createLeaderboard">
                    <el-option
                      class="select-primary"
                      label="Select Metric"
                      value=""
                    ></el-option>
                    <el-option
                      class="select-primary"
                      v-for="(source, key) in trackingSources"
                      :key="key"
                      :label="source.label"
                      :value="source.value"
                    >
                    </el-option>
                  </el-select>
                </b-input-group>
              </div>
            </b-list-group-item>
          </b-list-group>
        </b-col>
        <b-col lg="9" md="8">
          <sales-leaderboard :userRoute="userRoute" v-if="leaderboards.includes('sales')"></sales-leaderboard>
          <leaderboard :title="title(leaderboards[0])" :userRoute="userRoute" :activeLeaderboard="leaderboards[0]" v-if="singleLeaderboard"></leaderboard>
          <!-- <leaderboard :title="title(leaderboard)" :userRoute="userRoute" :activeLeaderboard="leaderboard" v-if="multipleLeaderboards" v-for="(leaderboard, key) in leaderboards" :key="key"></leaderboard> -->
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import trackingSources from './trackingSources';
import SalesLeaderboard from './SalesLeaderboard';
import { Select, Option } from 'element-ui';
import Leaderboard from './Leaderboard';

export default {
  components: {
    RouteBreadCrumb,
    SalesLeaderboard,
    [Select.name]: Select,
    [Option.name]: Option,
    Leaderboard
  },
  data() {
    return {
      trackingSources: trackingSources,
      addLeaderboard: false,
      activeLeaderboard: 'sales',
      boardToAdd: '',
      menu: [],
      leaderboards: ['sales'],
      editing: false,
    }
  },
  computed: {
    ...mapGetters({
      userRoute: 'profile/userRoute',
      roles: 'roles/roles'
    }),
    singleLeaderboard() {
      return this.leaderboards.length == 1 && !this.leaderboards.includes('sales');
    },
    multipleLeaderboards() {
      return this.leaderboards.length > 1 && !this.leaderboards.includes('sales');
    }
  },
  methods: {
    async getLeaderboardMenu() {
      await axios.get(this.userRoute + "/leaderboards/menu?section=team")
      .then(response => {
        this.mapMenu(response.data);
      })
    },
    async getCustomTrackingSources() {
      await axios.get(this.userRoute + "/tracking-sources")
      .then(response => {
        response.data.forEach((source) => {
          this.trackingSources.push({ value: source.slug, label:source.name });
        });
        this.getLeaderboardMenu();
      })
      .catch(error => {
        // error
      });
    },
    createLeaderboard() {
      let leaderboard = this.trackingSources.filter((s) => {
        return s.value == this.boardToAdd;
      })[0];

      axios.post(this.userRoute + "/leaderboards/menu", {
        type: leaderboard.value,
        section: 'team',
        default: 0,
        order: 0
      })
      .then(response => {
        this.getLeaderboardMenu();
        this.boardToAdd = '';
        this.addLeaderboard = false;
      })
      .catch(error => {

      });      
    },
    editMenu(item) {
      if(!this.editing){
        this.updateMenu(item);
      } else {
        this.removeMenuItem(item);
      }
    },
    updateMenu(item) {
      if (item.value == 'sales') {
        this.leaderboards = ['sales'];
      } else {
        // if (this.leaderboards.includes('sales')) {
        //   this.leaderboards.splice(this.leaderboards.indexOf('sales'), 1);
        // }

        // if (this.leaderboards.includes(item.value)) {
        //   this.leaderboards.splice(this.leaderboards.indexOf(item.value), 1);
        // } else {
        //   this.leaderboards.push(item.value);
        // }

        this.leaderboards = [item.value];
      }
    },
    removeMenuItem(item) {
      if (item.value !== 'sales') {
        axios.post(this.userRoute + "/leaderboards/menu/remove-item", {
          leaderboard: item.value
        })
        .then(response => {
          this.getLeaderboardMenu();
        })
      }
    },
    mapMenu(menu) {
      this.menu = [
        {
          title: 'Sales Leaderboard',
          value: 'sales',
        }
      ];

      menu.forEach((item) => {
        let source = this.trackingSources.filter((s) => {
          return s.value == item.type;
        })[0];

        if (source) {
          this.menu.push({title: source.label, value: source.value});
        }
      });
    },
    title(leaderboard) {
      return this.menu.filter((i) => {
        return i.value == leaderboard;
      })[0].title;
    }
  },
  created() {
    this.getCustomTrackingSources();
  }
};
</script>
<style lang="scss">
.list-group-item.active {
  background-color: #7aa2b8 !important;
  border-color: #7aa2b8 !important;
}
</style>